module.exports = __webpack_public_path__ + "static/media/matched.06017074.svg";